<template>
	<div class="index" v-cloak>
		<div v-if="followHid && !subscribe && isWeixin" class="follow acea-row row-between-wrapper"
			style="height:0.7rem;padding:0 0.2rem;background-color:#626262;color:#fff;">
			<div> 点击“立即关注”即可关注公众号</div>
			<div class="acea-row row-middle">
				<div class="bnt" @click="followTap"
					style="margin-right:0.2rem;border-radius: 1rem;background-color:#00c049;padding:0.04rem 0.25rem;">
					立即关注</div>
				<span class="iconfont icon-guanbi" style="font-size: 0.3rem;" @click="closeFollow"></span>
			</div>
		</div>
		<Popup v-model="followCode" closeable :style="{ height: '9rem',width:'6rem',background:'none' }">
			<img :src="info.merchant_info.merchant_qrcode" style=" width: 100%;
				display: block;
				margin: auto;
				position: absolute;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;" />
		</Popup>
		<div class="header acea-row row-center-wrapper">
			<div class="logo"><img :src="logoUrl" /></div>
			<router-link :to="'/search?mid='+info.mid" class="search acea-row row-middle a">
				<span class="iconfont icon-xiazai5"></span>搜索商品
			</router-link>
			<!-- <div @click="share()"><img src="../../assets/images/share1.png" style="width: 20px;"/></div> -->
			<router-link :to="'/user/poster'" style="padding: 0.08rem 0 0;">
				<img src="../../assets/images/share1.png" style="width: 20px;" />
			</router-link>

		</div>
		<div class="slider-banner banner">
			<swiper :options="swiperOption" v-if="banner.length > 0">
				<swiper-slide v-for="(item, index) in banner" :key="index">
					<!-- <router-link :to="item.wap_url ? item.wap_url : ''" class="search acea-row row-middle">
						<img :src="item.pic" />
					</router-link> -->
					<a :href="item.wap_url ? item.wap_url : 'javascript:void(0);'" class="search acea-row row-middle">
						<img :src="item.pic" />
					</a>
				</swiper-slide>
				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>
		</div>
		<div class="nav acea-row">
			<div class="item" v-for="(item, index) in menus" :key="index">
				<!-- <div v-if="item.id==215" class="center" style="width: 100%">
					<wx-open-launch-weapp id="launch-btn" 
						username="gh_d67e2193171b" 
						path="pages/vmcbuy/vmcproduct/vmcproduct/0351000001"
						@launch="handleLaunchFn"
						@error="handleErrorFn">
						<script type="text/wxtag-template">
					        <div class="pictrue" style="">
					        	<img :src="item.pic" />
					        </div>
					        <div>{{ item.name }}</div>
						</script>
					</wx-open-launch-weapp>
				</div> -->
				<!-- <div @click="menu_go(item)" v-else> -->
				<div @click="menu_go(item)">
					<div class="pictrue">
						<img :src="item.pic" />
					</div>
					<div>{{ item.name }}</div>
				</div>
			</div>
		</div>
		<div class="news acea-row row-between-wrapper" style="padding: 0 0.5rem 0 0.3rem; ">
			<div style="border-left:3px #f57f00 solid;padding-left:5px;font-size: 0.30rem;">
				商品
				<span style="color:#f57f00;margin-left:2px">{{info.statistics.productCount}}件</span>
			</div>
			<div style="font-size: 0.30rem;">
				会员
				<span style="color:#f57f00;margin-left:2px">{{info.statistics.userCount}}人</span>
			</div>
			<div style="font-size: 0.30rem;">
				至尊会员
				<span style="color:#f57f00;margin-left:2px">{{info.statistics.superCount}}人</span>
			</div>
		</div>
		<div class="specialArea acea-row row-between-wrapper" v-if="activity.length">
			<router-link :to="{ path: '/yykcategory/' + 54 }" class="assemble" style="width:38%"
				v-if="info.merchant_info.is_use_cloud == 1">
				<img src="http://app.funengtuan.com/imgs/yyd.png" />
				<div class="text" style="top: 0.2rem;">
					<div class="name" style="font-size: 0.36rem;">智慧云药库</div>
					<div class="infor">海量药品等你来</div>
				</div>
			</router-link>
			<router-link :to="activityOne.wap_link ? activityOne.wap_link : ''" class="assemble" style="width:38%"
				v-else>
				<img :src="activityOne.pic" />
				<div class="text">
					<div class="name">{{ activityOne.title }}</div>
					<div class="infor">{{ activityOne.info }}</div>
				</div>
			</router-link>
			<div class="list acea-row row-column-between" style="width:59%">
				<router-link :to="item.wap_link ? item.wap_link : ''" class="item" v-for="(item, index) in activity"
					:key="index">
					<img :src="item.pic" />
					<div class="text">
						<div class="name">{{ item.title }}</div>
						<div class="infor">{{ item.info }}</div>
					</div>
				</router-link>
			</div>
		</div>
		<!-- <div class="wrapper" v-if="info.fastList.length > 0">
			<div class="title acea-row row-between-wrapper">
				<div class="text">
					<div class="name line1">品牌快速选择</div>
					<div class="line1">{{ info.fastInfo }}</div>
				</div>
				<router-link :to="'/category'" class="more">更多<span class="iconfont icon-jiantou"></span></router-link>
			</div>

			<div class="nav acea-row">
				<router-link
					:to="{path: '/goods_list',query: { id: item.id, title: item.cate_name ,is_exchange:item.is_exchange}}"
					class="item" v-for="(item, index) in info.fastList" :key="index">
					<div class="pictrue"><img :src="item.pic" /></div>
					<div>{{ item.cate_name }}</div>
				</router-link>
			</div>
		</div> -->
		<!-- <div v-if="info.bastBanner[0]">
			<div class="adver">
				<img :src="info.bastBanner[0].img" />
			</div>
		</div> -->
		<div v-if="info.brandInfo.length > 0">
			<router-link :to="{ path: '/hot_new_goods/' + 5 }" style="display:block">
				<div class="adver">
					<img src="http://app.funengtuan.com/imgs/ppzq.png" />
				</div>
			</router-link>
		</div>
		<div class="wrapper" v-if="info.brandInfo.length > 0">
			<div class="title acea-row row-between-wrapper">
				<div class="text">
					<div class="name line1">品牌专区</div>
					<div class="line1">{{ info.bastInfo }}</div>
				</div>
				<router-link :to="{ path: '/hot_new_goods/' + 5 }" class="more">更多
					<span class="iconfont icon-jiantou"></span>
				</router-link>
			</div>
			<Good-list :good-list="info.brandInfo" :mid="info.mid" :is_exchange="info.is_exchange" :is-sort="false">
			</Good-list>
		</div>
		<div v-if="info.bastBanner[0]">
			<router-link :to="{ path: '/hot_new_goods/' + 1 }" style="display:block">
				<div class="adver">
					<img :src="info.bastBanner[0].img" />
				</div>
			</router-link>
		</div>
		<div class="wrapper" v-if="info.bastList.length > 0">
			<div class="title acea-row row-between-wrapper">
				<div class="text">
					<div class="name line1">女性专区</div>
					<div class="line1">{{ info.bastInfo }}</div>
				</div>
				<router-link :to="{ path: '/hot_new_goods/' + 1 }" class="more">更多<span
						class="iconfont icon-jiantou"></span></router-link>
			</div>
			<Good-list :good-list="info.bastList" :mid="info.mid" :is_exchange="info.is_exchange" :is-sort="false">
			</Good-list>
		</div>
		<div v-if="lovely.img">
			<router-link :to="{ path: '/hot_new_goods/' + 3 }" style="display:block">
				<div class="adver">
					<img :src="lovely.img" />
				</div>
			</router-link>
		</div>
		<div class="wrapper" v-if="info.firstList.length > 0">
			<div class="title acea-row row-between-wrapper">
				<div class="text">
					<div class="name line1">
						防疫专区
					</div>
					<div class="line1">{{ info.firstInfo }}</div>
				</div>
				<router-link :to="{ path: '/hot_new_goods/' + 3 }" class="more">更多<span
						class="iconfont icon-jiantou"></span></router-link>
			</div>
			<Good-list :good-list="info.firstList" :mid="info.mid" :is_exchange="info.is_exchange" :is-sort="false">
			</Good-list>
		</div>
		<div v-if="info.merchant_info.is_use_cloud == 1">
			<router-link :to="{ path: '/yykcategory/' + 54 }" class="more" style="display: block;">
				<div class="adver">
					<img src="http://app.funengtuan.com/imgs/yyk.png" />
				</div>
			</router-link>
		</div>
		<div class="wrapper" v-if="info.merchant_info.is_use_cloud == 1">
			<div class="title acea-row row-between-wrapper">
				<div class="text">
					<div class="name line1">
						家庭常用药
					</div>
					<div class="line1">更多家庭常用药</div>
				</div>
				<router-link :to="{ path: '/yykcategory/' + 54 }" class="more">更多<span
						class="iconfont icon-jiantou"></span></router-link>
			</div>
			<Good-list :good-list="info.cloudProduct" :mid="info.mid" :is_exchange="info.is_exchange" is_yun="1"
				:is-sort="false"></Good-list>
		</div>
		<div data-v-5e7337c8="" class="wrapper">
			<div data-v-5e7337c8="" class="title acea-row row-between-wrapper">
				<div data-v-5e7337c8="" class="text">
					<!-- <div data-v-5e7337c8="" class="name line1">{{dingwei}}</div> -->
					<div data-v-5e7337c8="" class="name line1">附近连锁门店</div>
				</div>
			</div>
		</div>
		<div class="stores-box" v-if="merchant.length>0">
			<router-link :to="{ path: '/mendian/mendian/' + item.id}" class="more" v-for="(item, index) in merchant"
				:key="index">
				<div class="stores-block-box md">
					<div class="stores-one">
						<img :src="item.picture ? item.picture : require('../../../public/stores1.jpg') " alt="">
					</div>
					<div class="stores-two">
						<p>{{item.merchant_name}}</p>
						<p>
							<img src="../../../public/dp1.png" alt="">
							<img src="../../../public/dp1.png" alt="">
							<img src="../../../public/dp1.png" alt="">
							<img src="../../../public/dp1.png" alt="">
							<img src="../../../public/dp1.png" alt="">
						</p>
						<p class="stores-add-box">
						<p class="mui-ellipsis">{{item.address}}</p>
						<p>{{item.distance}}</p>
						</p>
					</div>
				</div>
			</router-link>
		</div>
		<div class="stores-box" v-else>
			<div style="text-align: center;padding: 30px 0;color: #BBBBBB;">暂无数据</div>
		</div>
		<div class="change_city" v-if="changeCityShow">
			<div class="mask" @click="change_city_hide"></div>
			<div class="body">
				<div class="title">城市选择</div>
				<div class="list">
					<div class="item" :class="{active : diquId == index}" v-for="(item, index) in info.diquList"
						@click="choose_city(index)">{{item}}</div>
				</div>
			</div>
		</div>
		<img src="../../assets/images/share-info.png" class="shareda" v-if="showda" @click="xiaoshida">
		<div class="bottomShare" v-show="bottomShow">
			<div class="bottomShare1" @click="sharep">
				<div class="iconfont icon-weixin3" style="font-size: 1rem;color: #05c04c;"></div>
				<span class="bottomShare111">分享到朋友圈</span>
			</div>
			<div class="bottomShare1" @click="setPosterImageStatus">
				<div class="iconfont icon-haibao" style="font-size: 1rem;color: #05c04c;"></div>
				<span class="bottomShare111">保存海报</span>
			</div>
		</div>
		<StorePoster v-on:setPosterImageStatus="setPosterImageStatus" :posterImageStatus="posterImageStatus"
			:posterData="posterData" :showPrice="showPrice"></StorePoster>
		<!-- </div> -->
		<div style="height:1.2rem;"></div>
		<div class="dialog" v-show="showMask == 'true'"
			style="position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,0.3);z-index: 10;">
			<div class="dialog-container"
				style="position: absolute;top:30%;width:80%;left:10%;right:10%;background:#fff;padding:5%;border-radius:10px;">
				<img src="http://app.funengtuan.com/imgs/yjsy.jpg" v-if="xcxewm==1"
					style="width:80%;display:block;margin:0 auto" />
				<div class="dialog-content" style="font-size:0.3rem;text-align:center;margin-bottom:20px">
					<div v-if="showMasktitle">
						{{showMasktitle}}
					</div>
					<div>
						{{showMasktext}}
					</div>

				</div>
				<div class="btns" style="display: flex;justify-content: space-around;">
					<div class="settlement" @click="closeBtn" style="background:rgb(230, 233, 241);padding:5px 10px">
						{{showok}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script src="//res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
	import wx from 'weixin-js-sdk'
	import {
		getwxconfig,
		getUser,
		editspread
	} from "@api/user";
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import "@assets/css/swiper.min.css";
	import GoodList from "@components/GoodList";
	import PromotionGood from "@components/PromotionGood";
	import CouponWindow from "@components/CouponWindow";
	import StorePoster from "@components/StorePoster";
	import {
		imageBase64
	} from "@api/public";
	import {
		getHomeData,
		getShare
	} from "@api/public";
	import cookie from "@utils/store/cookie";
	import {
		openShareAppMessage,
		openShareTimeline,
		wx_getLocation,
		ready
	} from "@libs/wechat";
	import {
		isWeixin
	} from "@utils/index";
	import {
		Popup
	} from 'vant';

	const HAS_COUPON_WINDOW = "has_coupon_window";

	export default {
		name: "Index",
		components: {
			Popup,
			swiper,
			swiperSlide,
			GoodList,
			PromotionGood,
			CouponWindow,
			StorePoster
		},
		props: {},
		data: function() {
			const {
				spread = 0
			} = this.$route.query;
			return {
				showMasktitle: "",
				showMasktext: "",
				showMask: false,
				posterData: {
					image: "",
					title: "",
					price: "",
					code: ""
				},
				subscribe: false,
				followHid: true,
				followCode: false,
				isWeixin: isWeixin(),
				showPrice: false,
				posterImageStatus: false,
				showda: false,
				bottomShow: false,
				showCoupon: false,
				logoUrl: "",
				userInfo: {},
				banner: [],
				menus: [],
				roll: [],
				activity: [],
				activityOne: {},
				info: {
					fastList: [],
					bastBanner: [],
					firstList: [],
					bastList: [],
					cloudProduct: [],
					merchant_info: {
						is_use_cloud: "0",
					},
					statistics: {
						productCount: "0",
						userCount: "0",
						superCount: "0",
					},
				},
				likeInfo: [],
				lovely: {},
				benefit: [],
				couponList: [],
				swiperOption: {
					pagination: {
						el: ".swiper-pagination",
						clickable: true
					},
					autoplay: {
						disableOnInteraction: false,
						delay: 2000
					},
					loop: true,
					speed: 1000,
					observer: true,
					observeParents: true
				},
				swiperRoll: {
					direction: "vertical",
					autoplay: {
						disableOnInteraction: false,
						delay: 2000
					},
					loop: true,
					speed: 1000,
					observer: true,
					observeParents: true
				},
				swiperScroll: {
					freeMode: true,
					freeModeMomentum: false,
					slidesPerView: "auto",
					observer: true,
					observeParents: true
				},
				swiperBoutique: {
					pagination: {
						el: ".swiper-pagination",
						clickable: true
					},
					autoplay: {
						disableOnInteraction: false,
						delay: 2000
					},
					loop: true,
					speed: 1000,
					observer: true,
					observeParents: true
				},
				swiperProducts: {
					freeMode: true,
					freeModeMomentum: false,
					slidesPerView: "auto",
					observer: true,
					observeParents: true
				},
				merchant: [],
				diquList: [],
				location: '112.58138,37.858257',
				// location: '',
				changeCityShow: false,
				diquId: 2,
				spread: spread,
				diquName: '太原',
				showok: "确定",
				xcxewm: "",
			};
		},
		// created() {
		// 	getwxconfig().then(res=>{
		// 		wx.config({
		// 			 appId: res.data.data.appid,
		// 			 timestamp: res.data.data.timestamp,
		// 			 nonceStr: res.data.data.noncestr,
		// 			 signature: res.data.data.signature,
		// 			 jsApiList: ['wx-open-launch-weapp'],//跳转小程序、获取定位信息、导航
		// 			 openTagList: ['wx-open-launch-weapp']//打开的标签名
		// 		});
		// 		wx.ready(function(){
		// 			var btn = document.getElementById("launch-btn");
		// 			btn.addEventListener("launch", function (e) {
		// 			   alert("打开成功");
		// 			});
		// 			btn.addEventListener("error", function (e) {
		// 			  alert("打开失败");
		// 			});
		// 		})
		// 	});
		// },
		mounted: function() {
			let that = this;
			getHomeData({
				location: this.location,
				diqu_id: this.diquId
			}).then(res => {
				if(res.data){
					console.log(1)
				}else{
					console.log(2)
				}
				that.posterData.image = res.data.logoUrl
				that.posterData.title = res.data.site_name
				that.posterData.price = ''
				that.posterData.code = res.data.code
				that.getImageBase64()
				that.logoUrl = res.data.logoUrl;
				that.$set(that, "banner", res.data.banner);
				that.$set(that, "menus", res.data.menus);
				that.$set(that, "roll", res.data.roll);
				that.$set(that, "activity", res.data.activity);
				var activityOne = res.data.activity.shift() || {};
				that.$set(that, "activityOne", activityOne);
				that.$set(that, "info", res.data.info);
				that.$set(that, "likeInfo", res.data.likeInfo);
				that.$set(
					that,
					"lovely",
					res.data.lovely.length ? res.data.lovely[0] : {}
				);
				that.$set(that, 'merchant', res.data.info.merchant);
				that.$set(that, "benefit", res.data.benefit);
				that.$set(that, "couponList", res.data.couponList);
				document.title = res.data.site_name;
				that.subscribe = res.data.subscribe;
				that.setOpenShare(); //获取定位
				this.showCoupon = !cookie.has(HAS_COUPON_WINDOW) &&
					res.data.couponList.some(coupon => coupon.is_use);
			});
			getUser().then(res => {
				that.$set(that, "userInfo", res.data);
				if (res.data.level) {
					sessionStorage.setItem("userlevel", res.data.level);
				} else {
					sessionStorage.setItem("userlevel", "11");
				}
				if (that.spread) {
					editspread(that.spread).then(res => {
						console.log(res)
					})
				}
			});
		},
		methods: {
			handleLaunchFn(e) {
				console.log(e)
			},
			handleErrorFn(e) {
				console.log(e)
			},
			closeBtn() {
				this.showMask = "false";
				this.xcxewm = "";
				this.showMasktitle = "";
			},
			menu_go(e) {
				let that = this;
				console.log(this.userInfo)
				if (e.name == "夜间售药") {
					this.showMask = "true";
					this.showMasktitle = "长按二维码识别二维码";
					this.showMasktext = "进入夜间售药小程序";
					this.showok = "关闭";
					this.xcxewm = 1;
					return false;
				}
				if (e.name == "红包商城") {
					this.showMask = "true";
					this.showMasktext = e.name + "升级中";
					return false;
				}
				that.$router.push({
					path: e.wap_url,
				});
			},
			closeFollow() {
				this.followHid = false;
			},
			followTap() {
				this.followCode = true;
			},
			closeFollowCode() {
				this.followCode = false;
				this.followHid = true;
			},
			sharep() {
				this.bottomShow = false
				this.showda = true
			},
			setPosterImageStatus() {
				// console.log(this.posterData)
				let that = this
				that.posterImageStatus = !that.posterImageStatus;
				that.bottomShow = false
			},
			xiaoshida() {
				this.showda = false
			},
			getImageBase64: function() {
				let that = this;
				imageBase64(this.posterData.image, this.posterData.code)
					.then(res => {
						that.posterData.image = res.data.image;
						that.posterData.code = res.data.code;
					})
					.catch(res => {
						that.$dialog.error(res.msg);
					});
			},
			// share(){
			// 	// this.bottomShow = !this.bottomShow
			// 	/user/poster
			// },
			change_city_show() {
				this.changeCityShow = true;
			},
			change_city_hide() {
				this.changeCityShow = false;
			},
			choose_city(e) {
				this.diquId = e;
				this.diquName = this.diquList[e];
				getHomeData({
					location: this.location,
					diqu_id: this.diquId
				}).then(res => {
					this.posterData.name = res.data.site_name
					this.$set(this, 'merchant', res.data.merchant);
				});
			},
			couponClose() {
				cookie.set(HAS_COUPON_WINDOW, 1);
			},
			setOpenShare: function() {
				let that = this;
				getShare().then(res => {
					var data = res.data.data;
					var configAppMessage = {
						desc: data.synopsis,
						title: data.title,
						link: location.href.split("?")["0"] + "?spread=" + that.userInfo.uid,
						imgUrl: data.img
					};
					var configTimeline = {
						title: data.title,
						link: location.href.split("?")["0"] + "?spread=" + that.userInfo.uid,
						imgUrl: data.img
					};
					if (isWeixin() === true) {
						ready().then(() => {
							//获得定位并更新门店数据
							wx_getLocation().then(res => {
								that.location = res.longitude + ',' + res.latitude;
								that.GLOBAL.location = that.location
								getHomeData({
									location: that.location,
									diqu_id: that.diquId
								}).then(res => {
									that.$set(that, 'merchant', res.data.info
										.merchant);
								});
							})
							openShareAppMessage(configAppMessage).then(() => {});
							openShareTimeline(configTimeline).then(() => {});
						});
					}
				});
			},
		}
	};
</script>
<style scoped>
	.a {
		width: 4.5rem !important;
		margin-right: 0.28rem !important;
		padding-right: 0 !important;
	}

	.shareda {
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 999;
	}

	.bottomShare {
		width: 100%;
		height: 100px;
		background-color: #FFFFFF;
		position: fixed;
		bottom: 50px;
		display: flex;
		align-items: center;
	}

	.bottomShare1 {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.index {
		background-color: #fff;
	}

	.stores-box .stores-block-box {
		width: 100%;
		padding: 10px;
		margin-bottom: 10px;
		background: white;
		display: flex;
		justify-content: space-between;
	}

	.stores-box .stores-block-box .stores-one {
		width: 27%;
	}

	.stores-box .stores-block-box .stores-two {
		width: 70%;
	}

	.stores-box .stores-block-box .stores-two p:nth-of-type(2) img {
		width: 17px;
	}

	.stores-box .stores-block-box .stores-two .stores-add-box p {
		float: left;
	}

	.stores-block-box img {
		width: 100%;
		border-radius: 8%;
	}

	.stores-two p {
		line-height: 25px;
	}

	.change_city {
		position: fixed;
		z-index: 99;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	.change_city .mask {
		background: none;
	}

	.change_city .body {
		width: 300px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: #fff;
		padding: 15px;
		border-radius: 10px;
		box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
		z-index: 99;
	}

	.change_city .body .title {
		font-size: 16px;
		margin-bottom: 10px;
	}

	.change_city .body .list {
		min-height: 84px;
	}

	.change_city .body .list .item {
		padding: 3px 0;
		display: inline-block;
		width: 20%;
		margin-right: 5%;
		text-align: center;
		margin-top: 5px;
		border: 1px solid #FFFFFF;
		border-radius: 5px;
	}

	.change_city .body .list .item.active {
		color: #FF0000;
		border: 1px solid #FF0000;
	}

	.adver {
		height: auto !important;
	}
</style>
